import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import dompurify from "isomorphic-dompurify";
import { useConfig } from "../../providers/useConfig";
import { useTranslations } from "../../providers/useTranslations";
import "./Recaptchabar.scss";
const { sanitize } = dompurify;
export const Recaptchabar = ({ className, isPaddingRemoved, sanitizeConfig = {} }) => {
    const config = useConfig();
    const { __ } = useTranslations();
    return (_jsx("div", { className: classNames("recaptchabar", className), "data-testid": "recaptchabar", children: _jsx("div", { className: classNames("text", {
                paddingRemoved: isPaddingRemoved,
            }), children: _jsx("p", { dangerouslySetInnerHTML: {
                    __html: sanitize(__("recaptchabar.label", [config.reCaptchaPrivacyPolicyUrl, config.reCaptchaTermsOfServiceUrl]), sanitizeConfig),
                } }) }) }));
};
//# sourceMappingURL=Recaptchabar.js.map